<template>

  <m-pay-generic-editor
    :loading="loading"
    :bean="user || newUser"
    :beanProperties="editableProperties"
    :readOnlyProperties="readOnlyProperties"
    :validationRules="editableRules"
    @cancel="cancel"
    @submit="submit"
  />

</template>

<script>

import MPayGenericEditor from './MPayGenericEditor';

export default {
  name: 'MPayUserEditor',

  props: ['user', 'loading'],

  components: { MPayGenericEditor },

  data: () => ({
    newUser: {
      firstName: '',
      lastName: '',
      phoneNumber: '',
      email: '',
    },
    editableProperties: [
      'firstName',
      'lastName',
      'phoneNumber',
    ],
    readOnlyProperties: [
      'email',
    ],
    editableRules: [
      'required|max:25',
      'required|max:25',
      'required|max:20',
      'required|max:254',
    ],
  }),

  methods: {
    submit(bean) {
      const model = Object.assign({}, bean);
      this.$emit('submit', model);
    },
    cancel() {
      this.$router.go(-1);
    },
  },

};
</script>

<style>
  .users-editor__input__not-changed input,
  .users-editor__input__not-changed .v-select__selection {
    color: grey !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/MPayUserDetailsEditor.vue